import React from "react";
import { connect, useSelector } from "react-redux";
import Button from "../shared/Button/Button";
import { commonStyles } from "../AuthenticationLayout/authenticationLayoutCommonStyling.tailwind";
import InputController from "../shared/Input/InputField/InputController";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import createPasswordValidationSchema from "./createPassword.validation";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import routeConstant, { REDIRECT_ON_LOGIN } from "../../lib/constants/routeConstant";
import { createPassword } from "../../redux/slices/authSlice";
import { storage } from "../../config/storage";
import OverlayLoader from "../shared/Loaders/OverlayLoader/OverlayLoader";
// import ProgressBar from "./ProgressBar";

const CreatePasswordForm = ( { setPassword }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { validate } = state || {}; // FOR DEMO I AM USING VALIDATE PROP REMOVE IT WHEN IMPLEMENTING IT FOR APPLICATION
  const {passwordPolicy} = useSelector((state) => state.passwordPolicy);
  const { isLoading: isCreating } = useSelector(state => state.auth)

  // controller and state handled by react-router-dom
  const { control, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(createPasswordValidationSchema(passwordPolicy)), // Use Yup resolver
  });

  // this function redirects to the default page if user tries to directly access this page
  // FOR DEMO
  // if(!state) {
  //   return <Navigate to={routeConstant.DEFAULT_PAGE} />
  // }
  // const { stateValue } = state;

  /**
   * This function creates new password for the user using the setPassword 
   * action creator. It takes the formData as an argument and creates a new 
   * object with password and confirmPassword properties. It then calls the 
   * setPassword action creator and if the resultAction is fulfilled, it 
   * navigates the user to the Select Sports page.
   */
  const createNewPassword = async (formData) => {
    const data = {
      nickname: formData.nickname,
      password: formData.password,
      confirmPassword: formData.confirmPassword
    }

    const resultAction = await setPassword(data);
    if (createPassword.fulfilled.match(resultAction)) { // if the resultAction is fulfilled(means response is successful) then user will be redirected to the appropriate page
      // check if we have some route to navigate from local-storage
      const defaultNavigation = storage.fetchFromLocalStorage.navigateOnLogin();
      // if we have no route to navigate from local-storage then navigate to default route
      const navigateToRoute = defaultNavigation ? defaultNavigation : REDIRECT_ON_LOGIN

      navigate(navigateToRoute, { replace: true, state: null });

      // now clear from local storage
      storage.destroyFromLocalStorage.navigateOnLogin();
    }
  }
  
  //FOR DEMO
  // If user tries to directly access this page he/she will be redirected to default path
  // if(!stateValue) {
  //   return <Navigate to={routeConstant.DEFAULT_PAGE} />
  // }
  if (!validate) {
    return <Navigate to={routeConstant.DEFAULT_PAGE} replace />
  }

  return (
    <div className={commonStyles.sub_container}>
      {isCreating && <OverlayLoader />}
      <form className={commonStyles.form_wrpr} onSubmit={handleSubmit(createNewPassword)}>
        {/* Input Fields */}
        <div className={commonStyles.input_fields_wrpr}>
          {/* Password */}
          <InputController
            autoFocus = {true}
            label="Enter Nick Name"
            name="nickname"
            control={control}
            error={!!errors.nickname}
            helperText={errors.nickname?.message}
          />

          {/* Password */}
          <InputController
            label="Enter Password"
            type="password"
            name="password"
            control={control}
            error={!!errors.password}
            helperText={errors.password?.message}
          />

          {/* Confirm Password */}
          <InputController
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            control={control}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword?.message}
          />
        </div>

        {/* Login Button */}
        <Button variant="primary" type="submit" disabled={isCreating} className={commonStyles.loginButton}>{isCreating ? `Creating...` : `Create Password`}</Button>
        {/* {!isCreating &&
          <Button variant="primary" type="submit" disabled={isCreating} className={commonStyles.loginButton}>{isCreating ? `Creating...` : `Create Password`}</Button>  
        }   */}
        {/* {isCreating && <ProgressBar isLoading={isCreating} />} */}
      </form>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setPassword: (data) => dispatch(createPassword(data)),
});

export default connect(null, mapDispatchToProps)(CreatePasswordForm);